export const MAXIMUM_CAMPAIGN_COUNT_UNDER_ACCOUNT = '10000';

export function formatTodayDate(): string {
  const today = new Date();

  const month = String(today.getMonth() + 1).padStart(2, '0');
  const day = String(today.getDate()).padStart(2, '0');
  const year = today.getFullYear();

  const formattedDate = `${month}/${day}/${year}`;
  return formattedDate;
}

export function formatTodayGridDate(): string {
  const today = new Date();

  const month = String(today.getMonth() + 1).padStart(2, '0');
  const day = String(today.getDate()).padStart(2, '0');
  const year = today.getFullYear();

  const formattedDate = `${year}-${month}-${day}`;
  return formattedDate;
}
